import { type ImgHTMLAttributes, useState } from 'react';

export function Image({
  src,
  alt,
  fallbackSrc,
  ...props
}: ImgHTMLAttributes<HTMLImageElement> & { fallbackSrc?: string }) {
  const [imgSrc, setImgSrc] = useState(src);

  // If the image fails to load, switch to the fallback source
  return <img src={imgSrc} alt={alt} onError={() => setImgSrc(fallbackSrc)} {...props} />;
}
